import { Action, createReducer, on } from '@ngrx/store';
import { TeamPermActions } from '../actions';
import { TeamPermStates } from '../states';
import { initialState } from '../states/team-permissions.states';

export const teamPermReducer = createReducer(
    initialState,

    // load teams in the team listing
    on(TeamPermActions.loadTeamsSuccess, (state, action) => ({...state, totalRecords: action.totalRecords})),
    on(TeamPermActions.loadTeamsFailure, (state, action) =>
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),
    // load members
    on(TeamPermActions.loadMembersFailure, (state, action) =>
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // update team
    on(TeamPermActions.updateTeamSuccess, (state, action) => ({...state, updateTeamListing: true})),
    on(TeamPermActions.updateTeamFailure, (state, action) =>
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // add member
    on(TeamPermActions.addMembersSucess, (state, action) => ({...state, updateMemberListing: true, updateAddMemberListing: true})),
    on(TeamPermActions.addMembersFailure, (state, action) =>
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // update member
    on(TeamPermActions.updateMemberSuccess, (state, action) => ({...state, updateMemberListing: true})),
    on(TeamPermActions.updateMemberFailure, (state, action) =>
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // delete member
    on(TeamPermActions.deleteMemberSuccess, (state, action) => ({...state, updateMemberListing: true})),
    on(TeamPermActions.deleteMemberFailure, (state, action) =>
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // update role
    on(TeamPermActions.updateRoleSuccess, (state, action) => ({...state, updateRoleListing: true})),
    on(TeamPermActions.updateRoleFailure, (state, action) =>
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    on(TeamPermActions.setCurrentUser, (state, action) => ({...state, currentUser: action.currentUser})),
    on(TeamPermActions.selectTeam, (state, action) => ({...state, selectedTeam: action.team})),
    on(TeamPermActions.selectTeamRole, (state, action) => ({...state, selectedTeamRole: action.teamRole})),
    on(TeamPermActions.selectDetailsForm, (state, action) => ({...state, detailsForm: action.form})),
    on(TeamPermActions.selectMember, (state, action) => ({...state, selectedMember: action.member})),
    on(TeamPermActions.setUpdateMemberListing, (state, action) => ({...state, updateMemberListing: action.update})),
    on(TeamPermActions.setUpdateRoleListing, (state, action) => ({...state, updateRoleListing: action.update})),

    on(TeamPermActions.selectGuid, (state, action) => ({...state, selectedGuid: action.guid})),
    on(TeamPermActions.setRequiresUpdate, (state, action) => ({...state, requiresUpdate: action.update})),
)

export function team_perm_reducer(state: TeamPermStates | undefined, action: Action) {
    return teamPermReducer(state.teamPerm, action);
}
